/**
 * @desc 根据父分类编码数组查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.ProductCategroyModel>>;
export function request(parentCategoryNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productCategroy/list/parentByArray/${parentCategoryNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
